import { render, staticRenderFns } from "./newsListMobile.vue?vue&type=template&id=82cf11de&scoped=true"
import script from "./newsListMobile.vue?vue&type=script&lang=js"
export * from "./newsListMobile.vue?vue&type=script&lang=js"
import style0 from "./newsListMobile.vue?vue&type=style&index=0&id=82cf11de&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "82cf11de",
  null
  
)

export default component.exports